const data = {
  title: "Floor 2-9",
  musicTrack: "MUSIC_WORLD2",
  theme: "GREEN",
  tilesWidth: 17,
  tilesHeight: 13,
  placements: [
    {
      type: "HERO_SPAWN",
      x: 3,
      y: 3,
    },
    {
      type: "PLACEMENT_TYPE_GOAL",
      x: 7,
      y: 3,
    },
    {
      type: "WATER",
      x: 2,
      y: 1,
    },
    {
      type: "WATER",
      x: 1,
      y: 1,
    },
    {
      type: "WATER",
      x: 1,
      y: 2,
    },
    {
      type: "WATER",
      x: 1,
      y: 3,
    },
    {
      type: "WATER",
      x: 1,
      y: 4,
    },
    {
      type: "WATER",
      x: 1,
      y: 5,
    },
    {
      type: "WATER",
      x: 5,
      y: 5,
    },
    {
      type: "WATER",
      x: 5,
      y: 4,
    },
    {
      type: "WATER",
      x: 5,
      y: 1,
    },
    {
      type: "WATER",
      x: 4,
      y: 1,
    },
    {
      type: "WATER",
      x: 3,
      y: 1,
    },
    {
      type: "WATER",
      x: 6,
      y: 1,
    },
    {
      type: "WATER",
      x: 7,
      y: 1,
    },
    {
      type: "WATER",
      x: 8,
      y: 1,
    },
    {
      type: "WATER",
      x: 9,
      y: 1,
    },
    {
      type: "WATER",
      x: 9,
      y: 2,
    },
    {
      type: "WATER",
      x: 9,
      y: 3,
    },
    {
      type: "WATER",
      x: 9,
      y: 4,
    },
    {
      type: "WATER",
      x: 8,
      y: 5,
    },
    {
      type: "WATER",
      x: 7,
      y: 5,
    },
    {
      type: "WATER",
      x: 6,
      y: 5,
    },
    {
      type: "WATER",
      x: 9,
      y: 5,
    },
    {
      type: "WATER",
      x: 1,
      y: 6,
    },
    {
      type: "WATER",
      x: 1,
      y: 7,
    },
    {
      type: "WATER",
      x: 1,
      y: 8,
    },
    {
      type: "WATER",
      x: 1,
      y: 9,
    },
    {
      type: "WATER",
      x: 10,
      y: 1,
    },
    {
      type: "CHIP",
      x: 11,
      y: 3,
    },
    {
      type: "WALL",
      x: 11,
      y: 2,
    },
    {
      type: "WALL",
      x: 10,
      y: 2,
    },
    {
      type: "WALL",
      x: 10,
      y: 4,
    },
    {
      type: "WALL",
      x: 12,
      y: 2,
    },
    {
      type: "WALL",
      x: 12,
      y: 4,
    },
    {
      type: "WATER",
      x: 13,
      y: 2,
    },
    {
      type: "WATER",
      x: 11,
      y: 1,
    },
    {
      type: "WATER",
      x: 12,
      y: 1,
    },
    {
      type: "WATER",
      x: 13,
      y: 1,
    },
    {
      type: "WATER",
      x: 13,
      y: 3,
    },
    {
      type: "WATER",
      x: 13,
      y: 4,
    },
    {
      type: "WATER",
      x: 13,
      y: 5,
    },
    {
      type: "WATER",
      x: 13,
      y: 9,
    },
    {
      type: "WATER",
      x: 12,
      y: 9,
    },
    {
      type: "WATER",
      x: 13,
      y: 7,
    },
    {
      type: "WATER",
      x: 13,
      y: 8,
    },
    {
      type: "WATER",
      x: 1,
      y: 10,
    },
    {
      type: "WATER",
      x: 13,
      y: 10,
    },
    {
      type: "WATER",
      x: 1,
      y: 11,
    },
    {
      type: "KEY",
      x: 3,
      y: 11,
      color: "GREEN",
    },
    {
      type: "WATER",
      x: 1,
      y: 12,
    },
    {
      type: "WATER",
      x: 13,
      y: 12,
    },
    {
      type: "WATER",
      x: 1,
      y: 13,
    },
    {
      type: "WATER",
      x: 2,
      y: 13,
    },
    {
      type: "WATER",
      x: 7,
      y: 13,
    },
    {
      type: "WATER",
      x: 8,
      y: 13,
    },
    {
      type: "WATER",
      x: 9,
      y: 13,
    },
    {
      type: "WATER",
      x: 12,
      y: 13,
    },
    {
      type: "WATER",
      x: 13,
      y: 13,
    },
    {
      type: "WATER",
      x: 14,
      y: 1,
    },
    {
      type: "WATER",
      x: 15,
      y: 1,
    },
    {
      type: "WATER",
      x: 16,
      y: 1,
    },
    {
      type: "WATER",
      x: 17,
      y: 1,
    },
    {
      type: "WATER",
      x: 17,
      y: 2,
    },
    {
      type: "WATER",
      x: 17,
      y: 3,
    },
    {
      type: "WATER",
      x: 17,
      y: 4,
    },
    {
      type: "WATER",
      x: 17,
      y: 5,
    },
    {
      type: "WATER",
      x: 17,
      y: 6,
    },
    {
      type: "WATER",
      x: 17,
      y: 7,
    },
    {
      type: "WATER",
      x: 17,
      y: 8,
    },
    {
      type: "WATER",
      x: 17,
      y: 9,
    },
    {
      type: "WATER",
      x: 17,
      y: 10,
    },
    {
      type: "WATER",
      x: 17,
      y: 11,
    },
    {
      type: "WATER",
      x: 17,
      y: 12,
    },
    {
      type: "WATER",
      x: 17,
      y: 13,
    },
    {
      type: "WATER",
      x: 17,
      y: 14,
    },
    {
      type: "WATER",
      x: 16,
      y: 13,
    },
    {
      type: "WATER",
      x: 15,
      y: 13,
    },
    {
      type: "WATER",
      x: 14,
      y: 13,
    },
    {
      type: "WATER",
      x: 16,
      y: 14,
    },
    {
      type: "SWITCH_WALL",
      x: 16,
      y: 8,
      isRaised: false,
    },
    {
      type: "SWITCH_WALL",
      x: 14,
      y: 8,
      isRaised: false,
    },
    {
      type: "WATER",
      x: 5,
      y: 2,
    },
    {
      type: "WALL",
      x: 10,
      y: 3,
    },
    {
      type: "WALL",
      x: 12,
      y: 3,
    },
    {
      type: "SWITCH_WALL",
      x: 15,
      y: 8,
      isRaised: false,
    },
    {
      type: "SWITCH",
      x: 15,
      y: 9,
    },
    {
      type: "SWITCH_WALL",
      x: 14,
      y: 12,
      isRaised: true,
    },
    {
      type: "SWITCH_WALL",
      x: 15,
      y: 12,
      isRaised: true,
    },
    {
      type: "SWITCH_WALL",
      x: 16,
      y: 11,
      isRaised: true,
    },
    {
      type: "SWITCH_WALL",
      x: 16,
      y: 12,
      isRaised: true,
    },
    {
      type: "KEY",
      x: 15,
      y: 11,
      color: "BLUE",
    },
    {
      type: "THIEF",
      x: 15,
      y: 10,
    },
    {
      type: "WALL",
      x: 14,
      y: 9,
    },
    {
      type: "WALL",
      x: 14,
      y: 10,
    },
    {
      type: "WALL",
      x: 16,
      y: 9,
    },
    {
      type: "WALL",
      x: 16,
      y: 10,
    },
    {
      type: "WATER",
      x: 7,
      y: 4,
    },
    {
      type: "WATER",
      x: 8,
      y: 4,
    },
    {
      type: "WATER",
      x: 8,
      y: 3,
    },
    {
      type: "WATER",
      x: 7,
      y: 2,
    },
    {
      type: "WATER",
      x: 6,
      y: 2,
    },
    {
      type: "WATER",
      x: 6,
      y: 4,
    },
    {
      type: "WATER",
      x: 8,
      y: 2,
    },
    {
      type: "SWITCH_WALL",
      x: 14,
      y: 5,
      isRaised: true,
    },
    {
      type: "SWITCH_WALL",
      x: 14,
      y: 4,
      isRaised: true,
    },
    {
      type: "SWITCH_WALL",
      x: 14,
      y: 3,
      isRaised: true,
    },
    {
      type: "SWITCH_WALL",
      x: 16,
      y: 3,
      isRaised: true,
    },
    {
      type: "SWITCH_WALL",
      x: 16,
      y: 4,
      isRaised: true,
    },
    {
      type: "SWITCH_WALL",
      x: 16,
      y: 5,
      isRaised: true,
    },
    {
      type: "SWITCH_WALL",
      x: 16,
      y: 2,
      isRaised: true,
    },
    {
      type: "SWITCH_WALL",
      x: 14,
      y: 2,
      isRaised: true,
    },
    {
      type: "WATER",
      x: 13,
      y: 11,
    },
    {
      type: "SWITCH_WALL",
      x: 14,
      y: 11,
      isRaised: true,
    },
    {
      type: "WATER",
      x: 14,
      y: 7,
    },
    {
      type: "WATER",
      x: 16,
      y: 7,
    },
    {
      type: "WATER_PICKUP",
      x: 15,
      y: 3,
    },
    {
      type: "SWITCH_WALL",
      x: 14,
      y: 6,
      isRaised: true,
    },
    {
      type: "SWITCH_WALL",
      x: 16,
      y: 6,
      isRaised: true,
    },
    {
      type: "SWITCH",
      x: 15,
      y: 5,
    },
    {
      type: "SWITCH_WALL",
      x: 15,
      y: 2,
      isRaised: true,
    },
    {
      type: "WALL",
      x: 2,
      y: 12,
    },
    {
      type: "WALL",
      x: 11,
      y: 10,
    },
    {
      type: "WALL",
      x: 11,
      y: 12,
    },
    {
      type: "WALL",
      x: 10,
      y: 12,
    },
    {
      type: "WALL",
      x: 10,
      y: 10,
    },
    {
      type: "WATER",
      x: 11,
      y: 9,
    },
    {
      type: "WATER",
      x: 10,
      y: 9,
    },
    {
      type: "WATER",
      x: 9,
      y: 9,
    },
    {
      type: "WALL",
      x: 4,
      y: 12,
    },
    {
      type: "WATER",
      x: 11,
      y: 13,
    },
    {
      type: "WATER",
      x: 10,
      y: 13,
    },
    {
      type: "WATER",
      x: 6,
      y: 13,
    },
    {
      type: "WATER",
      x: 5,
      y: 13,
    },
    {
      type: "WATER",
      x: 3,
      y: 13,
    },
    {
      type: "WATER",
      x: 4,
      y: 13,
    },
    {
      type: "WALL",
      x: 12,
      y: 12,
    },
    {
      type: "WALL",
      x: 12,
      y: 10,
    },
    {
      type: "LOCK",
      x: 3,
      y: 10,
      color: "GREEN",
    },
    {
      type: "WALL",
      x: 12,
      y: 6,
    },
    {
      type: "WALL",
      x: 12,
      y: 7,
    },
    {
      type: "WALL",
      x: 12,
      y: 8,
    },
    {
      type: "WALL",
      x: 11,
      y: 8,
    },
    {
      type: "WALL",
      x: 10,
      y: 8,
    },
    {
      type: "WALL",
      x: 10,
      y: 6,
    },
    {
      type: "WATER_PICKUP",
      x: 11,
      y: 7,
    },
    {
      type: "WATER",
      x: 13,
      y: 6,
    },
    {
      type: "THIEF",
      x: 15,
      y: 4,
    },
    {
      type: "SWITCH_WALL",
      x: 15,
      y: 6,
      isRaised: false,
    },
    {
      type: "THIEF",
      x: 15,
      y: 7,
    },
    {
      type: "WATER_PICKUP",
      x: 5,
      y: 3,
    },
    {
      type: "ENEMY_SPAWN",
      x: 3,
      y: 9,
      direction: "UP",
      enemyType: "ENEMY",
    },
    {
      type: "WATER",
      x: 5,
      y: 6,
    },
    {
      type: "WATER",
      x: 5,
      y: 9,
    },
    {
      type: "WALL",
      x: 2,
      y: 11,
    },
    {
      type: "WATER",
      x: 5,
      y: 8,
    },
    {
      type: "WATER",
      x: 5,
      y: 7,
    },
    {
      type: "ENEMY_SPAWN",
      x: 4,
      y: 11,
      direction: "RIGHT",
      enemyType: "ENEMY",
    },
    {
      type: "WATER",
      x: 8,
      y: 9,
    },
    {
      type: "WATER",
      x: 6,
      y: 9,
    },
    {
      type: "WATER",
      x: 7,
      y: 9,
    },
    {
      type: "WATER",
      x: 6,
      y: 3,
    },
    {
      type: "WALL",
      x: 8,
      y: 6,
    },
    {
      type: "WALL",
      x: 6,
      y: 6,
    },
    {
      type: "WALL",
      x: 6,
      y: 8,
    },
    {
      type: "WALL",
      x: 6,
      y: 7,
    },
    {
      type: "WALL",
      x: 8,
      y: 8,
    },
    {
      type: "WALL",
      x: 5,
      y: 10,
    },
    {
      type: "WALL",
      x: 6,
      y: 10,
    },
    {
      type: "WALL",
      x: 8,
      y: 10,
    },
    {
      type: "WALL",
      x: 9,
      y: 10,
    },
    {
      type: "WALL",
      x: 9,
      y: 12,
    },
    {
      type: "WALL",
      x: 5,
      y: 12,
    },
    {
      type: "WALL",
      x: 6,
      y: 12,
    },
    {
      type: "LOCK",
      x: 7,
      y: 10,
      color: "BLUE",
    },
    {
      type: "LOCK",
      x: 11,
      y: 6,
      color: "GREEN",
    },
    {
      type: "WATER",
      x: 4,
      y: 5,
    },
    {
      type: "WALL",
      x: 3,
      y: 12,
    },
    {
      type: "THIEF",
      x: 7,
      y: 11,
    },
    {
      type: "WALL",
      x: 9,
      y: 6,
    },
    {
      type: "WALL",
      x: 9,
      y: 8,
    },
    {
      type: "WALL",
      x: 7,
      y: 8,
    },
    {
      type: "LOCK",
      x: 7,
      y: 6,
      color: "BLUE",
    },
    {
      type: "WATER",
      x: 10,
      y: 7,
    },
    {
      type: "WATER",
      x: 8,
      y: 7,
    },
    {
      type: "SWITCH_WALL",
      x: 9,
      y: 7,
      isRaised: false,
    },
    {
      type: "SWITCH",
      x: 7,
      y: 7,
    },
    {
      type: "WATER",
      x: 2,
      y: 5,
    },
    {
      type: "WATER",
      x: 4,
      y: 9,
    },
    {
      type: "WATER",
      x: 2,
      y: 9,
    },
    {
      type: "SWITCH_WALL",
      x: 3,
      y: 5,
      isRaised: true,
    },
    {
      type: "WALL",
      x: 2,
      y: 10,
    },
    {
      type: "WALL",
      x: 4,
      y: 10,
    },
    {
      type: "WATER",
      x: 10,
      y: 5,
    },
    {
      type: "WATER",
      x: 12,
      y: 5,
    },
    {
      type: "WALL",
      x: 8,
      y: 12,
    },
    {
      type: "THIEF",
      x: 11,
      y: 5,
    },
    {
      type: "KEY",
      x: 5,
      y: 11,
      color: "BLUE",
    },
  ],
};

export default data;
